module.exports = __webpack_public_path__ + "img/star.787d2371.svg";